import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  initializeGtm() {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': 
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl+ 
                            '&gtm_auth=fjJD846E4vc1xm_tYRnfdQ&gtm_preview=env-3&gtm_cookies_win=x';
                            f.parentNode.insertBefore(j,f);
                          })(window,document,'script','dataLayer','GTM-MPJSTQLD');`;
    document.head.appendChild(gtmScript);
  }
}
